"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var EventManager = function EventManager(events) {
  var _subscriptions = [];
  var _idCounter = 0;
  return {
    subscribe:
    /*Number*/
    function subscribe(
    /*String*/
    event,
    /*Function*/
    callback) {
      var id = _idCounter++;

      _subscriptions.push({
        event: event,
        callback: callback,
        id: id
      });

      return id;
    },
    unsubscribe:
    /*void*/
    function unsubscribe(
    /* Number */
    id) {
      for (var i = 0; i < _subscriptions.length; i++) {
        if (id === _subscriptions[i].id) _subscriptions.splice(i, 1);
      }
    },
    publish:
    /*void*/
    function publish(event, args) {
      var subscriptions = this._getSubscriptions(event);

      for (var i = 0; i < subscriptions.length; i++) {
        subscriptions[i].callback.apply(null, args);
      }
    },
    getEvents:
    /*Hash*/
    function getEvents() {
      return events;
    },
    _getSubscriptions: function _getSubscriptions(
    /*String*/
    event) {
      var subscriptions = [];

      for (var i = 0; i < _subscriptions.length; i++) {
        if (_subscriptions[i].event === event) subscriptions.push(_subscriptions[i]);
      }

      return subscriptions;
    }
  };
};

var _default = EventManager;
exports.default = _default;